import React from 'react';
import styled from 'styled-components';
import { themeGet } from '../..';
import sx from '../../sx';
const StyledCode = styled.code.withConfig({
  displayName: "Code__StyledCode",
  componentId: "sc-smdxrb-0"
})(["font-size:0.875em;font-weight:normal;background-color:", ";color:", ";border-style:none;border-radius:3px;display:inline;padding:2px 0.5ch;white-space:pre-wrap;overflow-wrap:break-word;overflow:auto;-webkit-box-decoration-break:clone;", ""], themeGet('colors.background.neutral.default'), themeGet('colors.text.default'), sx);
const Code = ({
  children,
  sx
}) => {
  return /*#__PURE__*/React.createElement(StyledCode, {
    sx: sx
  }, children);
};
Code.displayName = "Code";
Code.displayName = 'Code';
export default Code;